import React, { useCallback, useEffect, useState } from "react";
import styles from "./ProjectList.module.css";
import { CustomLoader, CustomTitle, CustomList, CustomAlert, CustomNotification, CustomButton } from "../../../components";
import { useTranslation } from "react-i18next";
import { deleteProject, getProjectListByUser } from "../../../services/projectService";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { useNavigate } from "react-router-dom";

const Projects = () => {
    
    const { t } = useTranslation();
    const navigate = useNavigate();
    const userId : number = useSelector((state: RootState) => state.auth.userId);

    const [isLoading, setIsLoading] = useState(true);
    const [isDeleteAlertOpen, setIsDeleteAlertOpen] = useState(false);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);

    const [selectedProject, setSelectedProject] = useState<ListElementType>();
    const [projectList, setProjectList] = useState<ListElementType[]>([]);

    const handleGetMyProjects = useCallback(async () => {
        const res = await getProjectListByUser(userId);
        const list: ListElementType[] = res?.data.data.map((item: any) => ({
            id : item.documentId,
            title : item.title || '',
            description : item.description || ''
        }));
        
        setProjectList(list);
        setIsLoading(false);
    }, [userId]);

    useEffect(() => {
        handleGetMyProjects();
    }, [handleGetMyProjects]);

    const handleDeleteProject = async () => {
        setIsDeleteAlertOpen(false);
        setIsLoading(true);

        if (selectedProject) {
            await deleteProject(selectedProject.id);
            await handleGetMyProjects();
        }

        setIsNotificationOpen(true);
        setIsLoading(false);
    }

    const goToEditProjectPage = (projectId: number) => {
        navigate('/account/projects/edit', { state : { isEditing : true, projectId : projectId } });
    }

    const goToCreateProjectPage = () => {
        navigate('/account/projects/edit', { state : { isEditing : false } });
    }

    return (
        <div className={styles.container}>
            { !isLoading &&
                <>
                    <div className={styles.containerTitle}>
                        <CustomTitle className={styles.title}>{ t('account.projects.title') }</CustomTitle>
                        <CustomButton onClick={() => goToCreateProjectPage()}>{ t('account.projects.new_project') }</CustomButton>
                    </div>
                    

                    <CustomList
                        onClick={(item: ListElementType) => goToEditProjectPage(item.id)}
                        onDeleteBtn={(item: ListElementType) => {
                            setSelectedProject(item);
                            setIsDeleteAlertOpen(true);
                        }}
                        list={projectList} />
                </>
            }

            <CustomAlert
                isOpen={isDeleteAlertOpen}
                onValid={() => handleDeleteProject()}
                onClose={() => setIsDeleteAlertOpen(false) }
                title={t('account.projects.delete_project')}
                content={`${t('account.projects.delete_project_msg')} "${selectedProject?.title}".`}
            />

            <CustomNotification
                message={t('account.projects.project_deleted')}
                isOpen={isNotificationOpen}
                onClose={() => setIsNotificationOpen(false)}
            />
        
            <CustomLoader loaderType="skeleton" isLoading={isLoading}/>
        </div>
    );
}

export default Projects;